import {
	ButtonUtility,
	DialogUntitledUI,
	Modal,
	ModalOverlay,
} from "@components";
import { Button } from "@components/button/button-untitledui";
import { Download01, XClose } from "@untitledui/icons";
import type { FormEvent, ReactNode } from "react";

type ExportRequestModalProps = {
	isOpen: boolean;
	title: string;
	description: string;
	onClose: () => void;
	onSubmit: () => void;
	isSubmitting?: boolean;
	isSubmitDisabled?: boolean;
	children: ReactNode;
};

export function ExportRequestModal({
	isOpen,
	title,
	description,
	onClose,
	onSubmit,
	isSubmitting = false,
	isSubmitDisabled = false,
	children,
}: ExportRequestModalProps) {
	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		onSubmit();
	};

	return (
		<ModalOverlay
			className="px-6"
			isOpen={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					onClose();
				}
			}}
		>
			<Modal className="relative mx-auto h-fit w-full max-w-[544px] overflow-hidden rounded-2xl bg-bg-primary">
				<form className="flex flex-col" onSubmit={handleSubmit}>
					<div className="flex flex-row items-start gap-4 border-border-secondary border-b border-solid p-6 pb-5">
						<div className="flex size-12 shrink-0 items-center justify-center rounded-[10px] border border-primary border-solid">
							<Download01
								aria-hidden="true"
								className="size-6 text-fg-secondary"
							/>
						</div>
						<div className="flex min-w-0 flex-1 flex-col gap-0.5 pr-8 text-left">
							<h2 className="font-semibold text-fg-primary text-md">{title}</h2>
							<p className="text-fg-tertiary text-sm">{description}</p>
						</div>
						<ButtonUtility
							aria-label="Fechar"
							className="absolute top-5 right-5"
							color="tertiary"
							icon={<XClose className="size-6 text-fg-quaternary" />}
							onClick={onClose}
							tooltip="Fechar"
						/>
					</div>

					<DialogUntitledUI
						aria-label={title}
						className="flex w-full min-w-0 flex-col gap-5 overflow-hidden px-6 py-5"
					>
						{children}
					</DialogUntitledUI>

					<div className="flex justify-end gap-3 border-border-secondary border-t border-solid px-6 py-4">
						<Button
							className="flex-1"
							color="secondary"
							onClick={onClose}
							size="md"
							type="button"
						>
							Cancelar
						</Button>
						<Button
							className="flex-1"
							color="primary"
							isDisabled={isSubmitDisabled || isSubmitting}
							isLoading={isSubmitting}
							size="md"
							type="submit"
						>
							Solicitar exportação
						</Button>
					</div>
				</form>
			</Modal>
		</ModalOverlay>
	);
}
